module.exports = __webpack_public_path__ + "img/179972.68fa467e.png";